function Section({ title, children }) {
  return (
    <>
      <div className="dash-section-header dash-item-full">
        <div className="dash-section-line" />
        <span className="dash-section-title">{title}</span>
        <div className="dash-section-line" />
      </div>
      {children}
    </>
  );
}

export default Section;
